import { matDatepickerAnimations } from '@angular/material/datepicker';
import { state, style, transition, animate } from '@angular/animations';
import { NgxMatDatetimePicker } from '@angular-material-components/datetime-picker';

/**
 * Override da animação de abertura do `mat-datepicker-content` (usado tb pelo
 * ngx-mat-datetime-picker que herda o mesmo trigger). O default do Material é
 * `scale(1, 0.8) → scale(1, 1)` (scaleY-only, "unfold"). Trocamos por scale
 * uniforme + fade — MESMA animação do `app-popover` (`jems-popover-in`) —
 * pra unificar a linguagem cinética dos overlays JEMS3.
 *
 * A trigger é um objeto compartilhado (`matDatepickerAnimations.transformPanel`)
 * capturado pelo `@Component({ animations: [...] })` do MatDatepickerContent.
 * Mutamos o array `.definitions` interno da trigger — Angular Animations
 * interpreta essas definições em cada transição em JIT (dev). Executar este
 * arquivo ANTES do bootstrap garante que o AOT/JIT compile já com o novo
 * conjunto de states/transitions.
 */
(matDatepickerAnimations.transformPanel as any).definitions = [
  state('void', style({ opacity: 0, transform: 'scale(0.8)' })),
  transition('void => enter', animate('120ms cubic-bezier(0, 0, 0.2, 1)', style({
    opacity: 1,
    transform: 'scale(1)',
  }))),
  transition('* => void', animate('100ms linear', style({ opacity: 0 }))),
];

/**
 * Override do position strategy do overlay do datepicker. O default do
 * `NgxMatDatetimePicker._createPopupPositionStrategy` tem 4 fallbacks
 * (start/end × bottom/top): se o input está na direita do viewport, CDK
 * cai pro end-align → painel encosta na borda direita do input, não à
 * esquerda. Aqui restringimos a 2 posições (start-bottom + start-top),
 * garantindo sempre alinhamento à esquerda com fallback vertical.
 */
(NgxMatDatetimePicker.prototype as any)._createPopupPositionStrategy = function () {
  return this._overlay.position()
    .flexibleConnectedTo(this.datepickerInput.getConnectedOverlayOrigin())
    .withTransformOriginOn('.mat-datepicker-content')
    .withFlexibleDimensions(false)
    .withViewportMargin(8)
    .withLockedPosition()
    .withPositions([
      { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
      { originX: 'start', originY: 'top',    overlayX: 'start', overlayY: 'bottom' },
    ]);
};
